//info publica

import React, { useState, useEffect } from 'react'
import { getOperadores } from '../../service/apiBackEnd.js';
import { Container, Row, Col, Table } from 'react-bootstrap';
import styles from '../index.module.css';

const InformacionPublica = () => {
    const [allData, setAllData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getOperadores();
            setAllData(res);
        };
        fetchData();
    }, []);
    console.log("DATAAAA", allData);

    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">Operadores</h1>

                <h3 className="mt-5 mb-4">Nacionales y Provinciales</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>N° Operador</th>
                            <th>Razon Social</th>
                            <th>Tipo</th>
                            <th>Tipo Gestión</th>
                            <th>Departamento</th>
                            <th>Localidad</th>
                            <th>Contacto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allData
                            .filter((elem) => elem.acf?.categoria.includes("Nacionales"))
                            .map((elem) => {
                                return (
                                    <tr>
                                        <td>{elem.acf.numero_de_operador}</td>
                                        <td>{elem.acf.razon_social}</td>
                                        <td>{elem.acf.tipo}</td>
                                        <td>{elem.acf.tipo_gestion}</td>
                                        <td>{elem.acf.departamento}</td>
                                        <td>{elem.acf.localidad}</td>
                                        <td>{elem.acf.contacto}</td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </Table>


                <hr></hr>

                <h3 className="mt-5 mb-4">Municipales</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>N° Operador</th>
                            <th>Razon Social</th>
                            <th>Tipo</th>
                            <th>Tipo Gestión</th>
                            <th>Departamento</th>
                            <th>Localidad</th>
                            <th>Contacto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allData
                            .filter((elem) => elem.acf?.categoria.includes("Municipales"))
                            .map((elem) => {
                                return (
                                    <tr>
                                        <td>{elem.acf.numero_de_operador}</td>
                                        <td>{elem.acf.razon_social}</td>
                                        <td>{elem.acf.tipo}</td>
                                        <td>{elem.acf.tipo_gestion}</td>
                                        <td>{elem.acf.departamento}</td>
                                        <td>{elem.acf.localidad}</td>
                                        <td>{elem.acf.contacto}</td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </Table>

                <hr></hr>

                <h3 className="mt-5 mb-4">Gestión Privada</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>N° Operador</th>
                            <th>Razon Social</th>
                            <th>Tipo</th>
                            <th>Tipo Gestión</th>
                            <th>Departamento</th>
                            <th>Localidad</th>
                            <th>Contacto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allData
                            .filter((elem) => elem.acf?.categoria.includes("Privada"))
                            .map((elem) => {
                                return (
                                    <tr>
                                        <td>{elem.acf.numero_de_operador}</td>
                                        <td>{elem.acf.razon_social}</td>
                                        <td>{elem.acf.tipo}</td>
                                        <td>{elem.acf.tipo_gestion}</td>
                                        <td>{elem.acf.departamento}</td>
                                        <td>{elem.acf.localidad}</td>
                                        <td>{elem.acf.contacto}</td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </Table>

                <hr></hr>

                <h3 className="mt-5 mb-4">Operadores Comunitarios</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>N° Operador</th>
                            <th>Razon Social</th>
                            <th>Tipo</th>
                            <th>Tipo Gestión</th>
                            <th>Departamento</th>
                            <th>Localidad</th>
                            <th>Contacto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allData
                            .filter((elem) => elem.acf?.categoria.includes("Operadores Comunitarios"))
                            .map((elem) => {
                                return (
                                    <tr>
                                        <td>{elem.acf.numero_de_operador}</td>
                                        <td>{elem.acf.razon_social}</td>
                                        <td>{elem.acf.tipo}</td>
                                        <td>{elem.acf.tipo_gestion}</td>
                                        <td>{elem.acf.departamento}</td>
                                        <td>{elem.acf.localidad}</td>
                                        <td>{elem.acf.contacto}</td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </Table>


            </Row>
        </Container>
    );
};
export default InformacionPublica